/** Client-side env helpers (Vite). */

export const isProd = import.meta.env.PROD
export const isDev = import.meta.env.DEV

export function getSiteUrl(): string {
  return (
    import.meta.env.VITE_SITE_URL ||
    import.meta.env.NEXT_PUBLIC_SITE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : 'https://tutorcat.online')
  )
}

export function getSupabaseUrl(): string | undefined {
  return import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL
}

export function getSupabaseServiceKey(): string {
  return import.meta.env.SUPABASE_SERVICE_KEY || ''
}
